export default "__VITE_ASSET__96db530e__"